import { Base } from '@itsrever/design-system'
import { Trans, useTranslation } from 'react-i18next'
import { ExchangeShippedNotice } from '@/domain/returns'

const { Callout } = Base

interface ExchangeShippedBannerProps {
  notice: ExchangeShippedNotice
  orderNumber: string
  orderUrl?: string
}

export const ExchangeShippedBanner = ({
  notice,
  orderNumber,
  orderUrl
}: ExchangeShippedBannerProps) => {
  const { t } = useTranslation()
  return (
    <Callout className="mb-4">
      <p className="text-sm font-semibold">
        {t(`process_details_page.exchange_shipped_notice.${notice}.title`)}
      </p>
      <p className="text-sm">
        <Trans
          i18nKey={`process_details_page.exchange_shipped_notice.${notice}.description`}
          values={{ order: orderNumber }}
          components={{
            orderLink: orderUrl ? (
              <a
                href={orderUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
              />
            ) : (
              <span />
            )
          }}
        />
      </p>
    </Callout>
  )
}
